import { createAction, props } from '@ngrx/store';
import { TimerStatus } from '../../../../features/calendar/calendar-types';
import { TimeBlockListEntry } from '../time-enty-list-types';

export const timeEntryListTrackerStarted = createAction(
  '[TimeEntryListTrackerStarted] Tracker Started',
  props<{
    payload: {
      status: TimerStatus;
      activeTimerEntry: TimeBlockListEntry;
    };
  }>(),
);
